module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-1"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mx-auto": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-card', {
    staticClass: "pa-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0 pt-0 pb-2 text-xs-center subheading"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    class: !_vm.config.IS_ADMIN ? 'xs7' : 'xs3'
  }, [_vm._v("\n                  Blocks"), _c('br'), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "value": 100,
      "size": 60,
      "width": 8
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.blocks.length) + "\n                ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_vm._v("\n                Units"), _c('br'), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "value": 100,
      "size": 60,
      "width": 8
    }
  }, [_vm._v("\n                " + _vm._s(_vm.totUnits) + "\n              ")])], 1), _vm._v(" "), (_vm.config.IS_ADMIN) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_vm._v("\n              Users"), _c('br'), (!_vm.$vuetify.breakpoint.smAndUp) ? _c('br') : _vm._e(), _vm._v(" "), _c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "value": 100 - _vm.unitsWithNOUsers.length / _vm.totUnits * 100,
      "size": 60,
      "width": 8
    }
  }, [_vm._v("\n              " + _vm._s(_vm.totUsers) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    class: 'ma-0 ' + (_vm.filterBy === 'U' ? 'primary' : 'grey lighten-4'),
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.filterList('U')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("filter_list")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.IS_ADMIN) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('span', [_vm._v("Units with no user")]), _c('br'), _vm._v(" "), _c('v-progress-circular', {
    attrs: {
      "color": "error",
      "value": _vm.unitsWithNOUsers.length / _vm.totUnits * 100,
      "size": 60,
      "width": 8
    }
  }, [_vm._v("\n            " + _vm._s(_vm.unitsWithNOUsers.length) + "\n          ")]), _vm._v(" "), _c('v-btn', {
    class: 'ma-0 ' + (_vm.filterBy === 'OU' ? 'primary' : 'grey lighten-4'),
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.filterList('OU')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("filter_list")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pt-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 mt-1",
    attrs: {
      "append-icon": "search",
      "placeholder": _vm.$vuetify.breakpoint.smAndUp ? 'Search by name, unit no, etc.' : 'Search',
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), (_vm.config.IS_ADMIN) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.unitHeadSm,
      "items": _vm.residents.filter(function (rec) { return (!_vm.filterBy || (_vm.filterBy === 'U' && rec.user_id) || (_vm.filterBy === 'OU' && rec.is_orphan_unit) || (_vm.filterBy === 'NU' && !rec.user_id && !rec.is_orphan_unit)); }),
      "title": "Resident directory",
      "fontsize": 9,
      "landscape": true
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [(_vm.residents.filter(function (rec) { return !rec.user_id && !rec.is_orphan_unit; }).length) ? _c('div', {
    staticClass: "text-xs-right caption warning--text"
  }, [_vm._v("\n        * Not Integra user, but someone from that unit using app\n        "), _c('v-btn', {
    class: 'ma-0 ' + (_vm.filterBy === 'NU' ? 'info' : 'grey lighten-4'),
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.filterList('NU')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("filter_list")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.unitHeadSm : _vm.unitHead,
      "items": _vm.residents.filter(function (rec) { return (!_vm.filterBy || (_vm.filterBy === 'U' && rec.user_id) || (_vm.filterBy === 'OU' && rec.is_orphan_unit) || (_vm.filterBy === 'NU' && !rec.user_id && !rec.is_orphan_unit)); }),
      "disable-initial-sort": "",
      "rows-per-page-items": [10, 25, 50, {
        'text': '$vuetify.dataIterator.rowsPerPageAll',
        'value': -1
      }],
      "pagination": _vm.pagination,
      "search": _vm.search
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: props.item.is_orphan_unit ? 'error--text' : props.item.user_id ? '' : 'warning--text',
          on: {
            "click": function($event) {
              return _vm.showUnit(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.block_and_unit))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cust_name))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.ownership))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.int_extn))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.contact_phone_view))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.contact_email_view))]) : _vm._e()])]
      }
    }], null, false, 282844407)
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.isViewed),
      callback: function($$v) {
        _vm.isViewed = $$v
      },
      expression: "isViewed"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 grey lighten-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.isViewed = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-3 py-0"
  }, [_c('div', {
    staticClass: "text-xs-center pb-2"
  }, [_c('div', {
    staticClass: "headline pt-2"
  }, [_vm._v(_vm._s(_vm.lResident.cust_name))]), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.lResident.block_nm + ' ' + _vm.lResident.unit_no))]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.lResident.ownership + (_vm.lResident.user_id ? ' & Uniservice App user' : '')))]), _vm._v(" "), _c('v-avatar', {
    staticClass: "grey lighten-4 ma-2",
    attrs: {
      "size": 120
    }
  }, [(_vm.lResident.avatar_url) ? _c('img', {
    attrs: {
      "src": _vm.config.STATIC_FILES_DIR + _vm.lResident.avatar_url
    }
  }) : _c('v-icon', {
    attrs: {
      "color": "grey",
      "size": "110px"
    }
  }, [_vm._v("person")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Intercom")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lResident.int_extn))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Mobile")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [(_vm.config.IS_USER_EMPOWERED) ? _c('span', [_vm._v(_vm._s(_vm.lResident.contact_phone))]) : _c('span', [_vm._v(_vm._s(_vm.lResident.contact_phone_view))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [(false) ? _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "disabled": _vm.lResident.hide_contact,
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("content_copy")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("E-mail")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [(_vm.config.IS_USER_EMPOWERED) ? _c('span', [_vm._v(_vm._s(_vm.lResident.contact_email))]) : _c('span', [_vm._v(_vm._s(_vm.lResident.contact_email_view))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [(false) ? _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "disabled": _vm.lResident.hide_contact,
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("content_copy")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Emergency")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lResident.emergency_phone))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [(false) ? _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("content_copy")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Blood Group")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lResident.blood_group))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Occupation")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lResident.occupation))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs4": ""
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Hobbies")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lResident.hobbies))])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.config.IS_ADMIN) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.lResident.user_id !== null
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteResident()
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareUpdate(_vm.lResident)
      }
    }
  }, [_vm._v("Update")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lAction === 'create' || _vm.lAction === 'update'),
      expression: "lAction === 'create' || lAction === 'update'"
    }],
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lResident.cust_name),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "cust_name", $$v)
      },
      expression: "lResident.cust_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Gender",
      "items": ['Male', 'Female'],
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lResident.gender),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "gender", $$v)
      },
      expression: "lResident.gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Block",
      "items": _vm.blockList,
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "25"
    },
    on: {
      "input": function($event) {
        return _vm.findBlockId()
      }
    },
    model: {
      value: (_vm.lResident.block_nm),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "block_nm", $$v)
      },
      expression: "lResident.block_nm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Unit no.",
      "rules": [_vm.rules.required],
      "items": _vm.unitList,
      "hide-details": "",
      "maxlength": "10"
    },
    on: {
      "input": function($event) {
        return _vm.findUnitId()
      }
    },
    model: {
      value: (_vm.lResident.unit_no),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "unit_no", $$v)
      },
      expression: "lResident.unit_no"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "pt-0",
    attrs: {
      "row": _vm.$vuetify.breakpoint.smAndUp,
      "mandatory": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.lResident.ownership),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "ownership", $$v)
      },
      expression: "lResident.ownership"
    }
  }, _vm._l((_vm.resRolesList), function(curRole, ridx) {
    return _c('v-radio', {
      key: ridx,
      attrs: {
        "label": curRole.role_name,
        "value": curRole.role_name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm3": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": (_vm.config.COMM_COUNTRY_CODE === 'MY' ? 'JMB/' : 'RWA/') + 'MC Member',
      "hide-details": ""
    },
    model: {
      value: (_vm.lResident.is_mc_member),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "is_mc_member", $$v)
      },
      expression: "lResident.is_mc_member"
    }
  })], 1), _vm._v(" "), (_vm.lResident.is_mc_member) ? _c('v-flex', {
    attrs: {
      "xs7": "",
      "sm9": ""
    }
  }, [_c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Role",
      "items": _vm.mcRolesList,
      "item-text": "role_name",
      "item-value": "role_id",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lResident.role_id),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "role_id", $$v)
      },
      expression: "lResident.role_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Contact Information")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('vue-tel-input-vuetify', {
    ref: "refMob",
    attrs: {
      "label": "Mobile number",
      "rules": [_vm.rules.required],
      "input-options": {
        showDialCode: true
      },
      "maxlength": "15"
    },
    on: {
      "input": _vm.keepCursor,
      "validate": _vm.validateMob
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.ignoreBackspace.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.mobileNo),
      callback: function($$v) {
        _vm.mobileNo = $$v
      },
      expression: "mobileNo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lResident.contact_email),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "contact_email", $$v)
      },
      expression: "lResident.contact_email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Other Information (optional)")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Intercom no.",
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.lResident.int_extn),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "int_extn", $$v)
      },
      expression: "lResident.int_extn"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Emergency phone",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lResident.emergency_phone),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "emergency_phone", $$v)
      },
      expression: "lResident.emergency_phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Blood group",
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.lResident.blood_group),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "blood_group", $$v)
      },
      expression: "lResident.blood_group"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Occupation",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lResident.occupation),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "occupation", $$v)
      },
      expression: "lResident.occupation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Hobbies",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lResident.hobbies),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "hobbies", $$v)
      },
      expression: "lResident.hobbies"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Address")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Address",
      "hide-details": "",
      "maxlength": "150"
    },
    model: {
      value: (_vm.lResident.address),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "address", $$v)
      },
      expression: "lResident.address"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "City",
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lResident.city),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "city", $$v)
      },
      expression: "lResident.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "PIN Code",
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.lResident.pin_code),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "pin_code", $$v)
      },
      expression: "lResident.pin_code"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "State",
      "maxlength": "25"
    },
    model: {
      value: (_vm.lResident.state),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "state", $$v)
      },
      expression: "lResident.state"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Tax Information")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "GST Identification No.",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.lResident.gst_no),
      callback: function($$v) {
        _vm.$set(_vm.lResident, "gst_no", $$v)
      },
      expression: "lResident.gst_no"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.lAction === 'upload') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "subheading"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "my-3 text-xs-center primary--text title"
  }, [_c('i', [_vm._v("Upload residents in just 4 easy steps")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 1")]), _vm._v(" "), _c('span', [_vm._v("Download template "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('span', [_vm._v("by clicking on download button")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('form', {
    attrs: {
      "method": "get",
      "action": "../static/files/Smartility_Resident_Directory.xlsx"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0",
    attrs: {
      "type": "submit",
      "small": ""
    }
  }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 2")]), _vm._v(" "), _c('span', [_vm._v("Fill-in details as guided in template")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 3")]), _vm._v(" "), _c('span', [_vm._v("Save the Excel file as CSV "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(Comma delimited)")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caption grey--text pl-4 ml-4"
  }, [_c('span', {
    staticClass: "ml-4"
  }, [_vm._v("Choose OK/Yes when prompted while saving")])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 4")]), _vm._v(" "), _c('span', [_vm._v("Upload the CSV file "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('span', [_vm._v("by clicking on upload button")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 mb-0 accent",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.promptUpload.apply(null, arguments)
      }
    }
  }, [_c('v-icon', [_vm._v("file_upload")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "ipFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": function($event) {
        return _vm.validateFile()
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "my-3 text-xs-center primary--text title"
  }, [_c('i', [_vm._v("Integra takes care of rest")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 5")]), _vm._v(" "), _c('span', [_vm._v("Validate your information")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "primary--text",
    attrs: {
      "small": "",
      "disabled": "",
      "outline": ""
    }
  }, [_vm._v("Step 6")]), _vm._v(" "), _c('span', [_vm._v("Create resident records")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges.apply(null, arguments)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")]), _vm._v(" Back")], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lAction === 'validate') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n              Upload Resident Directory\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-xs-center pl-2 pr-2"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md9": "",
      "mx-auto": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "info--text mb-2",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.validateInProgress) ? _c('span', [_vm._v("Loading and validating the file...")]) : _vm._e(), _vm._v(" "), (_vm.validFile && !_vm.validateInProgress) ? _c('span', [_vm._v("File validation is successfull "), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile) ? _c('span', [_vm._v("File validation is failed "), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (!_vm.validFile && _vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("Invalid column headers, please ensure names and count are matching as per the template")]) : _vm._e(), _vm._v(" "), (!_vm.validFile && !_vm.headerIssue) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more invalid records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e(), _vm._v(" "), (!_vm.totFail && !_vm.loadInProgress) ? _c('span', [_vm._v("Resident directory creation was successfull"), _c('v-icon', {
    staticClass: "success--text"
  }, [_vm._v("check")])], 1) : _vm._e(), _vm._v(" "), (!_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Resident directory creation failed"), _c('v-icon', {
    staticClass: "error--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totLoaded && _vm.totFail && !_vm.loadInProgress) ? _c('span', [_c('br'), _vm._v("Resident directory creation partially failed"), _c('v-icon', {
    staticClass: "warning--text"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (_vm.totFail && !_vm.loadInProgress) ? _c('span', {
    staticClass: "error--text"
  }, [_c('br'), _vm._v("One or more failed records, review the table below."), _c('br'), _vm._v("Click on the errored row to know more info.")]) : _vm._e()]), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "value": _vm.readyForLoad ? 100 : (_vm.recsLoaded.length / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.readyForLoad ? _vm.totValid : _vm.recsLoaded.length) + "\n                    ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Records")])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "success",
      "value": (_vm.totValid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.readyForLoad ? _vm.totLoaded : _vm.totValid) + "\n                  ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Loaded' : 'Valid'))])], 1) : _vm._e(), _vm._v(" "), (_vm.totRecs) ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "error",
      "value": (_vm.totInvalid / _vm.totRecs * 100),
      "size": 50,
      "width": 7
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.readyForLoad ? _vm.totFail : _vm.totInvalid) + "\n                ")]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v(_vm._s(_vm.readyForLoad ? 'Failed' : 'Invalid'))])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.lAction = 'upload'
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.totValid > 0) ? _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "small": "",
      "disabled": _vm.beingSaved
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadResidents.apply(null, arguments)
      }
    }
  }, [_vm._v("Process the valid records")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-3 text-xs-left",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.loadHeadSm : _vm.loadHead,
      "items": _vm.recsLoaded,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: (props.item.error ? (props.item.load_status === 'Failed' ? 'error' : 'error--text') : (props.item.load_status === 'Loaded' ? 'success' : '')),
          on: {
            "click": function($event) {
              props.item.error ? _vm.showError(props.item.error) : ''
            }
          }
        }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.block_nm))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.unit_no))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.bhk))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.acc_sqft))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.ownership))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cust_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contact_phone))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.contact_email))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.gender))]) : _vm._e()])]
      }
    }], null, false, 4237995306)
  })], 1)], 1)], 1), _vm._v(" "), (false) ? _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")])], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.IS_USER_EMPOWERED && _vm.lAction === 'view') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate.apply(null, arguments)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (_vm.config.IS_USER_EMPOWERED && _vm.lAction === 'view') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:15px;' : 'bottom:15px; left:315px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "small": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareUpload.apply(null, arguments)
      }
    }
  }, [_c('v-icon', [_vm._v("file_upload")])], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 4000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20%",
      "left": "50%"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-715579d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Residents.vue
// module id = 916
// module chunks = 20